import React from 'react';
import { cn } from '@/lib/utils';

interface CardGlowProps {
  className?: string;
  color?: string;
  variant?: 'regular' | 'subtle' | 'strong';
  children: React.ReactNode;
}

export function CardGlow({
  className,
  color = 'hsl(var(--villavie-blue))',
  variant = 'subtle',
  children
}: CardGlowProps) {
  // Define opacity based on variant
  const getOpacity = () => {
    switch(variant) {
      case 'subtle': return '0.07';
      case 'strong': return '0.2';
      case 'regular':
      default: return '0.12';
    }
  };

  return (
    <div className={cn('relative group rounded-lg transition-all', className)}>
      {/* Gradient background */}
      <div 
        className="absolute inset-0 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        style={{
          background: `radial-gradient(circle at center, ${color} 0%, transparent 70%)`,
          opacity: getOpacity()
        }}
      />
      
      {/* Border glow effect */}
      <div 
        className="absolute -inset-px rounded-lg opacity-0 group-hover:opacity-100 blur-sm transition-opacity duration-300"
        style={{
          background: `linear-gradient(45deg, ${color}20, ${color}50, ${color}20)`,
        }}
      />
      
      {/* Actual content */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
} 